import React, { useState, useEffect } from "react";
import "./carousel.css";
import { bannerVideo2, bannerVideo3, gallery_eagle_video } from "../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const videos = [
  gallery_eagle_video,
  // bannerVideo2,
  // bannerVideo3,
];

const VideoCarouselComponent: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animation, setAnimation] = useState("");

  useGSAP(() => {
    gsap.from(".gsapBanner", {
      y: -30,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      delay: 1,
    });
  });

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000); 

    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToPrevious = () => {
    setAnimation("fade-out");
    // setTimeout(() => {
    //   const newIndex = currentIndex === 0 ? videos.length - 1 : currentIndex - 1;
    //   setCurrentIndex(newIndex);
    //   setAnimation("fade-in");
    // }, 500); 
  };

  const goToNext = () => {
    setAnimation("fade-out");
    // setTimeout(() => {
    //   const newIndex = currentIndex === videos.length - 1 ? 0 : currentIndex + 1;
    //   setCurrentIndex(newIndex);
    //   setAnimation("fade-in");
    // }, 500); 
  };

  return (
    <div className="carousel">
      {/* <button onClick={goToPrevious} className="carousel-button prev">
        ❮
      </button> */}
      <div className="carousel-videos gsapBanner">
        <video
          autoPlay
          loop
          muted
          playsInline
          key={currentIndex}
        >
          <source src={videos[currentIndex]} type="video/mp4" />
        </video>
        <div className="carousel-content">
          <h1 className="titlesFontFamily">Welcome To Eagle Villa</h1>
        </div>
      </div>
      {/* <button onClick={goToNext} className="carousel-button next">
        ❯
      </button> */}
      {/* <div className="carousel-dots">
        {videos.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => {
              setAnimation("fade-out");
              setTimeout(() => {
                setCurrentIndex(index);
                setAnimation("fade-in");
              }, 500);
            }}
          ></span>
        ))}
      </div> */}
    </div>
  );
};

export default VideoCarouselComponent;
